export default __webpack_public_path__ + "static/media/caisse.5a8425b5.jpg";